<template>
  <div class="analysisreport-communicationTypeDetailReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <span class="mr10 fs14 color-666">{{ $t("Analysisreport.cb") }}：</span>
          <div class="select-box" style="width: 260px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0')
              "
              :picker-options="pickerOptions"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.track_linktype"
              clearable
              filterable
              :placeholder="$t('Analysisreport.ch')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.linktypeList"
                :key="`${Math.random()}${index}`"
                :label="item.commode_name"
                :value="item.commode_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.client_tracestatus"
              clearable
              filterable
              :placeholder="$t('Analysisreport.bf')"
              @change="search"
            >
              <!--0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单-->
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')
                "
                value="0"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')
                "
                value="1"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')
                "
                value="2"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')
                "
                value="3"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')
                "
                value="4"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')
                "
                value="-1"
              ></el-option>
              <el-option
                :label="
                  $t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')
                "
                value="-2"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10 Inquire-box">
          <div class="ipt-box" style="width: 280px">
            <el-input
              v-model="filter.keyword"
              clearable
              :placeholder="$t('Analysisreport.ci')"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelCrmDetailReport.51h4yx8fut40")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
import http from "../analysisreport.js";
export default {
  name: "analysisreport-communicationTypeDetailReport",
  data() {
    return {
      reportParams: {
        wayString: "trackDetailByLinkType", //传递到子组件的方法名称
        Title: "沟通类型明细表",
      },
      //筛选
      filter: {
        rang_time: "", //选择时间--必须定义为这个参数
        start_time: "",
        end_time: "",
        track_linktype: "",
        client_tracestatus: "", //名单状态
        keyword: "", //关键词
        coursetype_id: "", //班组
        coursecat_id: "",
      },
      // 筛选的下拉列表
      filterList: {
        linktypeList: [], //选择渠道类型-下拉数据
        coursetypeList: [], //班组-下拉数据
        courseCatList: [],
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  updated() {},
  created() {
    this.getCommodeApi();
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();

    this.filter.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.filter.start_time = this.$Common.getAppointedDate(2, 0).startDate;
    this.filter.end_time = this.$Common.getAppointedDate(2, 0).endDate;
  },
  computed: {},
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    getCommodeApi() {
      http.getCommodeApi({}).then((res) => {
        (() => {})(res);
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.filterList.linktypeList = data.list;
        } else {
          this.filterList.linktypeList = [];
        }
      });
    },
    //检索
    search() {
      this.filter.start_time = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.end_time = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.$refs["auto_height_table"]) {
    //     this.tableList.options.tableHeight = this.$Tool.getTableHeight(
    //       this.$refs.auto_height_table.getBoundingClientRect().top + 75
    //     );
    //   }
    // });
  },
};
</script>
<style lang="less">
.analysisreport-communicationTypeDetailReport {
  .el-main {
    margin-bottom: 0px;
  }
}
</style>
